<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="add_view_edit_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogViewForm"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              需求信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <!-- <el-col :span="6">
                  <el-form-item label="需求类型">
                    <el-input
                      v-model="dialogViewForm.typeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col> -->
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="市场">
                    <el-input
                      v-model="dialogViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求方">
                    <el-input
                      v-model="dialogViewForm.demandSide"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.type === 2"
                :gutter="10"
              >
                <el-col :span="24">
                  <el-form-item label="需求来源">
                    <el-input
                      v-model="dialogViewForm.schemeContent"
                      type="textarea"
                      autosize
                      disabled
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.type === 1"
                :gutter="10"
              >
                <el-col :span="12">
                  <el-form-item label="方案名称">
                    <el-input
                      v-model="dialogViewForm.schemeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="方案编号">
                    <el-input
                      v-model="dialogViewForm.schemeNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求类型">
                    <el-input
                      v-model="dialogViewForm.schemeTypeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="需求来源">
                    <el-input
                      v-model="dialogViewForm.schemeContent"
                      type="textarea"
                      autosize
                      disabled
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="方案开始日期">
                    <el-input
                      v-model="dialogViewForm.schemeStartDateValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求结束日期">
                    <el-input
                      v-model="dialogViewForm.schemeEndDateValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求物料名称">
                    <el-input
                      v-model="dialogViewForm.demandMaterialsName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求物料数量">
                    <el-input
                      v-model="dialogViewForm.demandMaterialsNumberUnit"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              申请信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="需求是否执行">
                    <el-input
                      v-model="dialogViewForm.isExecuteValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.isExecute === 1"
                  :span="6"
                >
                  <el-form-item label="需求执行方式">
                    <el-input
                      v-model="dialogViewForm.executeMethodValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.isExecute === 1 && dialogViewForm.demandSort === 1"
                :gutter="10"
              >
                <el-col :span="12">
                  <el-form-item label="物料名称">
                    <el-input
                      v-model="dialogViewForm.materialsName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="物料单位">
                    <el-input
                      v-model="dialogViewForm.materialsUnitName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 1"
                  :span="6"
                >
                  <el-form-item label="申请制作数量">
                    <el-input
                      v-model="dialogViewForm.applyMakeNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 2"
                  :span="6"
                >
                  <el-form-item label="备用库存满足数量">
                    <el-input
                      v-model="dialogViewForm.applySpareStockMeetsNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 1"
                  :span="6"
                >
                  <el-form-item label="收货库房">
                    <el-input
                      v-model="dialogViewForm.receiveDepotName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 1"
                  :span="6"
                >
                  <el-form-item label="收货人">
                    <el-input
                      v-model="dialogViewForm.receiver"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 1"
                  :span="6"
                >
                  <el-form-item label="收货联系电话">
                    <el-input
                      v-model="dialogViewForm.receivePhone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 1"
                  :span="6"
                >
                  <el-form-item label="收货地址">
                    <el-input
                      v-model="dialogViewForm.receiveAddress"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.isExecute === 1 && dialogViewForm.demandSort === 2"
                :gutter="10"
              >
                <el-col
                  v-if="dialogViewForm.executeMethod === 3"
                  :span="12"
                >
                  <el-form-item label="租赁物料内容">
                    <el-input
                      v-model="dialogViewForm.leaseMaterials"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 3"
                  :span="6"
                >
                  <el-form-item label="租赁数量">
                    <el-input
                      v-model="dialogViewForm.leaseNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="租赁备注说明">
                    <el-input
                      v-model="dialogViewForm.leaseDirections"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.isExecute === 2"
                :gutter="10"
              >
                <el-col :span="24">
                  <el-form-item label="不执行原因">
                    <el-input
                      v-model="dialogViewForm.ignoreReason"
                      type="textarea"
                      disabled
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
        <el-form
          ref="dialogAuditForm"
          :model="dialogAuditForm"
          :rules="dialogAuditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              审核确认信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item
                    label="审核结果"
                    prop="auditResult"
                  >
                    <el-radio-group v-model="dialogAuditForm.auditResult">
                      <el-radio
                        :label="1"
                        :disabled="dialogViewForm.isExecute === 2 || dialogAuditForm.executeMethod === 3"
                      >
                        新制作/购买
                      </el-radio>
                      <el-radio
                        :label="2"
                        :disabled="dialogViewForm.isExecute === 2 || dialogAuditForm.executeMethod === 3"
                      >
                        调拨
                      </el-radio>
                      <el-radio
                        :label="3"
                        :disabled="dialogViewForm.isExecute === 2 || dialogAuditForm.executeMethod === 1"
                      >
                        外部租赁
                      </el-radio>
                      <el-radio :label="5">
                        退回
                      </el-radio>
                      <el-radio :label="4">
                        不执行(不结算)
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogAuditForm.auditResult === 1"
                :gutter="10"
              >
                <el-col :span="6">
                  <el-form-item
                    label="新制作数量"
                    prop="auditMakeNumber"
                  >
                    <el-input
                      v-model="dialogAuditForm.auditMakeNumber"
                      @input="(val)=>{limitPositiveNumber(val, dialogAuditForm, 'auditMakeNumber')}"
                      @blur="setNumberValueDefaultZero($event, dialogAuditForm, 'auditMakeNumber', 2)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="确认供应方"
                    prop="confirmSupplier"
                  >
                    <el-radio-group v-model="dialogAuditForm.confirmSupplier">
                      <el-radio :label="1">
                        总部制作
                      </el-radio>
                      <el-radio :label="2">
                        当地制作
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogAuditForm.auditResult === 2"
                :gutter="10"
              >
                <el-col :span="6">
                  <el-form-item
                    label="调拨满足数量"
                    prop="auditAllocateNumber"
                  >
                    <el-input
                      v-model="dialogAuditForm.auditAllocateNumber"
                      :disabled="!depotOptions || depotOptions.length === 0"
                      @input="(val)=>{limitPositiveNumber(val, dialogAuditForm, 'auditAllocateNumber')}"
                      @blur="setNumberValueDefaultZero($event, dialogAuditForm, 'auditAllocateNumber', 2)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="调出库房">
                    <el-select
                      v-model="dialogAuditForm.auditAllocateDepotId"
                      filterable
                      clearable
                      placeholder="请选择调出库房"
                      style="width:100%"
                      @change="allocateDepotChangeFun"
                    >
                      <el-option
                        v-for="item in depotOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="调出库房备用库存数量">
                    <el-input
                      v-model="dialogAuditForm.allocateStockNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <!-- 存在备用库存的库房及库存数量TABLE -->
                <el-col
                  v-if="spareStockData && spareStockData.length > 0"
                  :span="24"
                >
                  <el-table
                    :data="spareStockData"
                    style="width: 100%"
                    :header-cell-style="{background:'#19a4ced3'}"
                  >
                    <el-table-column
                      v-for="(column, index) in spareStockHeader"
                      :key="index"
                      :label="column.label"
                      :prop="column.prop"
                      width="125"
                      header-align="center"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ scope.row[column.prop] }}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogAuditForm.auditResult !== 1 && dialogAuditForm.auditResult !== 2 && dialogAuditForm.auditResult !== 3"
                :gutter="10"
              >
                <el-col :span="24">
                  <el-form-item
                    label="审核意见"
                    prop="auditOpinion"
                  >
                    <el-input
                      v-model="dialogAuditForm.auditOpinion"
                      type="textarea"
                      placeholder="请输入审核意见"
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>

        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-input
                  v-model="dialogViewForm.remark"
                  type="textarea"
                  disabled
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// import { getUserId } from '@/utils/auth'
// 数据请求
import { initMaterialsDemandApi, auditMaterialsDemandApi } from '@/api/materialsDemandDetail'
import { loadSpareInventoryDataApi } from '@/api/inventoryInfo'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    },
    sendObject: {
      type: Object,
      default: null
    }
  },
  data() {
    // 确认供应方
    const validateConfirmSupplier = (rule, value, callback) => {
      if (this.dialogAuditForm.auditResult === 1 && this.dialogAuditForm.executeMethod === 1 && Number(this.dialogAuditForm.auditMakeNumber) > 0) {
        if (value === '' || value === 0) {
          callback(new Error('请确认制作物料供应方'))
        } else {
          callback()
        }
      } else {
        callback()
      }

    }
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogViewForm: {},
      dialogAuditForm: {},
      dialogAuditFormRules: {
        auditResult: [{ required: true, message: '请选择审核结果', trigger: ['change', 'blur'] }],
        auditMakeNumber: [{ required: true, message: '请输入确认的新制作数量', trigger: ['change', 'blur'] }],
        auditAllocateNumber: [{ required: true, message: '请输入确认的调拨满足数量', trigger: ['change', 'blur'] }],
        confirmSupplier: [{ required: true, validator: validateConfirmSupplier, trigger: 'change' }],
        auditOpinion: [{ required: true, message: '请输入审核意见', trigger: 'blur' }, { max: 255, message: '审核意见最多输入255个字符', trigger: 'blur' }],
      },
      spareStockHeader: [], // 备用库存清单表头
      spareStockData: [], // 存在物料备用库存的库房及库存数量集合
      depotOptions: []

    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogViewForm.clearValidate()
        })

        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.operateButtonDisable = false

        this.dialogViewForm = {}
        this.dialogAuditForm = {}
        this.depotOptions = []
        this.spareStockHeader = []
        this.spareStockData = []

        this.initData()
      }
    }
  },
  methods: {
    // 加载数据
    initData() {
      initMaterialsDemandApi({ id: this.dataId }).then(response => {
        const { data } = response

        this.dialogViewForm = data
        this.dialogViewForm.demandMaterialsNumberUnit = data.demandMaterialsNumber + ' ' + data.demandMaterialsUnit

        let defaultResult = 0
        if (data.isExecute === 2) {
          defaultResult = 4
        } else if (data.executeMethod === 1) {
          defaultResult = 1
        } else if (data.executeMethod === 3) {
          defaultResult = 3
        }

        this.dialogAuditForm = {
          id: data.id,
          executeMethod: data.executeMethod,
          auditResult: defaultResult,
          auditMakeNumber: data.applyMakeNumber,
          auditSpareStockMeetsNumber: data.applySpareStockMeetsNumber,
          auditAllocateNumber: 0,
          auditAllocateDepotId: '',
          auditAllocateDepotName: '',
          auditOpinion: '',
          confirmSupplier: 0,
          allocateStockNumber: 0 // 调出库房备用库存数量
        }

        if (data.isExecute === 1 && data.executeMethod === 1) {
          // 获取存在物料备用库存的库房数据
          this.loadMaterialsSpareStockDataFun()
        } else {
          this.loading = false
        }

      })
    },
    // 获取所以非本地市场的物料备用库存信息【库房、数量】
    loadMaterialsSpareStockDataFun() {
      let materialsId = this.dialogViewForm.materialsId || 0
      let filterCityId = this.dialogViewForm.cityId || 0
      loadSpareInventoryDataApi({ materialsId: materialsId, filterCityId: filterCityId }).then(response => {
        let data = response.data
        if (data && data.length > 0) {
          // 封装备用库存tableData和表头数组
          let stockNumberData = {}
          data.forEach(item => {
            // 表头数组
            this.spareStockHeader.push({
              prop: 'amount_' + item.depotId,
              label: item.depotName
            })
            // table数据
            stockNumberData['amount_' + item.depotId] = item.amount
          })
          this.spareStockData.push(stockNumberData)

          // 封装调出库房下拉框
          data.forEach(item => {
            this.depotOptions.push({
              value: item.depotId,
              label: item.depotName,
              amount: item.amount
            })
          })
        }
        this.loading = false
      })
    },
    // 选择库房回调
    allocateDepotChangeFun(val) {
      let selectItem = {}
      selectItem = this.depotOptions.find(item => {
        return item.value === val
      })
      this.dialogAuditForm.auditAllocateDepotName = selectItem ? selectItem.label : ''
      this.dialogAuditForm.allocateStockNumber = selectItem ? selectItem.amount : 0
    },

    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAuditForm.clearValidate()
    },
    // 保存
    handleSave() {
      this.$refs.dialogAuditForm.validate(valid => {
        if (valid) {
          // 审核结果为确认 需求方式为制作/购买
          if (this.dialogAuditForm.auditResult === 1 && this.dialogAuditForm.executeMethod === 1) {
            // 如果存在调拨满足数量 验证是否选择了调出库房
            if (this.dialogAuditForm.auditAllocateNumber > 0 && !this.dialogAuditForm.auditAllocateDepotId) {
              this.$message({ message: '请选择调出库房', type: 'warning' })
              return false
            }
            // 验证调拨满足数量是否超过了库房备用库存数量
            if (this.dialogAuditForm.auditAllocateNumber > 0 && Number(this.dialogAuditForm.auditAllocateNumber) > Number(this.dialogAuditForm.allocateStockNumber)) {
              this.$message({ message: '确认的调拨满足数量不能超过调出库房的备用库存数量', type: 'warning' })
              return false
            }
            // 验证新制作数量+调拨满足数量是否超过了申请制作数量
            if (Number(this.dialogViewForm.applyMakeNumber) < (Number(this.dialogAuditForm.auditMakeNumber) + Number(this.dialogAuditForm.auditAllocateNumber))) {
              this.$message({ message: '确认满足数量不能超过申请制作数量', type: 'warning' })
              return false
            }
          }
          this.$confirm(
            '是否确定审核物料需求申请', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            this.operateButtonDisable = true
            this.loading = true
            this.loadingText = '正在处理数据中，请耐心等待'


            if (this.dialogAuditForm.auditResult < 3) {
              this.dialogAuditForm.auditOpinion = ''
              if (this.dialogAuditForm.auditResult === 1) {
                this.dialogAuditForm.auditSpareStockMeetsNumber = 0
                this.dialogAuditForm.auditAllocateNumber = 0
                this.dialogAuditForm.auditAllocateDepotId = 0
                this.dialogAuditForm.auditAllocateDepotName = ''
              } else if (this.dialogAuditForm.auditResult === 2) {
                this.dialogAuditForm.auditMakeNumber = 0
                this.dialogAuditForm.confirmSupplier = 0
              }
            } else {
              this.dialogAuditForm.auditMakeNumber = 0
              this.dialogAuditForm.auditSpareStockMeetsNumber = 0
              this.dialogAuditForm.auditAllocateNumber = 0
              this.dialogAuditForm.auditAllocateDepotId = 0
              this.dialogAuditForm.auditAllocateDepotName = ''
              this.dialogAuditForm.confirmSupplier = 0
            }

            auditMaterialsDemandApi(this.dialogAuditForm).then(res => {
              if (res.mark === '200') {
                this.$message({ message: res.message, type: 'success' })
                this.reloadData()
                this.modalClose()
              }
            }).catch(() => {
              this.loading = false
              this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
  .test {
    color: #19a4ced3;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}
.source-textarea {
  ::v-deep .el-textarea__inner {
    margin-top: 0px;
    font-size: 12px;
  }
}
</style>
